import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

// Patrón shadcn: clsx + tailwind-merge para deduplicar clases conflictivas.
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}

// Formatea un RUT chileno (12345678-9) preservando guión y dígito verificador.
// Si el input ya viene normalizado, lo devuelve igual.
export function formatRut(rut: string): string {
  const cleaned = rut.replace(/[^0-9kK]/g, '').toUpperCase();
  if (cleaned.length < 2) return cleaned;
  const body = cleaned.slice(0, -1);
  const dv = cleaned.slice(-1);
  return `${body}-${dv}`;
}

// Formato de fecha humano legible. Locale es-CL para coherencia con el negocio.
export function formatDate(date: Date | string): string {
  const d = typeof date === 'string' ? new Date(date) : date;
  return new Intl.DateTimeFormat('es-CL', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  }).format(d);
}

export function formatDateTime(date: Date | string): string {
  const d = typeof date === 'string' ? new Date(date) : date;
  return new Intl.DateTimeFormat('es-CL', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  }).format(d);
}
